import React, { useState, useEffect } from "react";
import { Grid, useTheme } from "@material-ui/core";
import Card from "./Card";
import { useSelector } from "react-redux";
import NumberFormat from "react-number-format";

export default function Cards() {
  const theme = useTheme();
  const dashboard = useSelector((state) => state.externalReports);
  const groups = useSelector((state) => state.groups);

  const [data, setData] = useState({
    removals: 0,
    greenPoints: 0,
    kilograms: 0,
    users: 0,
    groups: 0,
    adminUsers: 0,
  });

  const convertNumber = (quantity) => {
    if (Math.round(quantity).toString().length < 4) {
      return Math.round(quantity) + " Kg";
    } else {
      return Math.round(quantity / 1000) + " Ton";
    }
  };

  useEffect(() => {
    if (dashboard.data) {
      setData({
        ...data,
        removals: dashboard.data.removals?.length,
        greenPoints: dashboard.data?.greenPoints,
        kilograms: dashboard.data?.materialsTemp.total,
        users: dashboard.data?.users,
        adminUsers: dashboard.data?.adminUsers,
        groups: groups.groupsSelect?.length,
      });
    }
  }, [dashboard.data]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <Card
          title="REGISTROS EXTERNOS"
          value={
            <NumberFormat
              value={Math.round(data.removals)}
              displayType={"text"}
              thousandSeparator={"."}
              decimalSeparator={","}
            />
          }
          background={theme.palette.primaryGradient.main}
          link="/admin/external-removals"
        />
      </Grid>
      <Grid item xs={4}>
        <Card
          title="CANTIDAD RECICLADA"
          value={convertNumber(data.kilograms)}
          background={theme.palette.primaryGradient.main}
          link="/admin/external-reports"
        />
      </Grid>
      <Grid item xs={4}>
        <Card
          title="PUNTOS GIRA EXTERNOS ACTIVOS"
          value={
            <NumberFormat
              value={Math.round(data.greenPoints)}
              displayType={"text"}
              thousandSeparator={"."}
              decimalSeparator={","}
            />
          }
          background={theme.palette.primaryGradient.main}
          link="/admin/external-greenPoints"
        />
      </Grid>
      <Grid item xs={4}>
        <Card
          title="GRUPOS"
          value={
            <NumberFormat
              value={Math.round(data.groups)}
              displayType={"text"}
              thousandSeparator={"."}
              decimalSeparator={","}
            />
          }
          background={theme.palette.primaryGradient.main}
          link="/admin/external-greenPoints"
        />
      </Grid>
      <Grid item xs={4}>
        <Card
          title="ADMINISTRADORES EXTERNOS ACTIVOS"
          value={
            <NumberFormat
              value={Math.round(data.adminUsers)}
              displayType={"text"}
              thousandSeparator={"."}
              decimalSeparator={","}
            />
          }
          background={theme.palette.primaryGradient.main}
          link="/admin/external-users"
        />
      </Grid>
      <Grid item xs={4}>
        <Card
          title="MONITORES EXTERNOS ACTIVOS"
          value={
            <NumberFormat
              value={Math.round(data.users)}
              displayType={"text"}
              thousandSeparator={"."}
              decimalSeparator={","}
            />
          }
          background={theme.palette.primaryGradient.main}
          link="/admin/external-users"
        />
      </Grid>
      <Grid item xs={12}>
        <hr />
      </Grid>
    </Grid>
  );
}
